import { render } from "./ProjectSneakPeek.vue?vue&type=template&id=6b84b222&scoped=true&ts=true"
import script from "./ProjectSneakPeek.vue?vue&type=script&lang=ts"
export * from "./ProjectSneakPeek.vue?vue&type=script&lang=ts"

import "./ProjectSneakPeek.vue?vue&type=style&index=0&id=6b84b222&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b84b222"]])

export default __exports__